import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import "./Layout.css";

const Layout = () => {
  return (
    <div className="mainLayout">
      <div className="layoutHeader">
        <Navbar />
      </div>
      <main>
        <Outlet />
      </main>
      <div className="layoutFooter">
        <Footer />
      </div>

      {/* Floating Quote Button */}
      <a href="/quote" className="floating-quote-btn">
        Get a Quote
      </a>
    </div>
  );
};

export default Layout;
